// extracted by mini-css-extract-plugin
module.exports = {"language":"LanguagePicker_language__1upr2","flag":"LanguagePicker_flag__dOnXN"};